import jwtDecode from "jwt-decode";

export const set = (key, value) => {
  sessionStorage.setItem(key, JSON.stringify(value))
  return get(key)
}

export const get = key => {
  let retorno = JSON.parse(sessionStorage.getItem(key))
  return retorno
}

export const getUser = () => {
  const token = sessionStorage.getItem('authSistema');
  if (!token) return undefined;
  
  try {
    const user = jwtDecode(token);
    return user;
  } catch (error) {
    console.error('Erro ao decodificar token:', error);
    return undefined;
  }
}

const ROLE_CLAIM = "http://schemas.microsoft.com/ws/2008/06/identity/claims/role";

export const getUserRoles = () => {
  const user = getUser();
  if (!user) return [];

  const roles = user[ROLE_CLAIM] || user.role || user.roles || [];
  return Array.isArray(roles) ? roles : [roles];
}

export const hasRole = (roleName) => {
  return getUserRoles().some(
    (role) => String(role).toLocaleLowerCase() === roleName.toLocaleLowerCase()
  );
}

export const isMidia = () => hasRole("Midia");

export const clear = key => {
  sessionStorage.clear()
  localStorage.removeItem('isAuthenticated')
}
